import { jsx, jsxs } from '@emotion/react/jsx-runtime';

// src/utils/createIcon.ts
var ICON_SYMBOL = Symbol("$$shopl.isShoplIcon");
function isShoplIcon(arg) {
  return typeof arg === "function" && arg[ICON_SYMBOL] === true;
}
function createIcon(source) {
  source[ICON_SYMBOL] = true;
  return source;
}
function SvgSubtract(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#D9F4ED",
          fillRule: "evenodd",
          d: "M2.5 7a4.5 4.5 0 0 0 4.303-5.82A11.953 11.953 0 0 1 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12c0-1.862.424-3.624 1.18-5.197A4.5 4.5 0 0 0 2.5 7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var Subtract_default = createIcon(SvgSubtract);
function SvgIcAdd(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M10 3a1 1 0 0 1 .993.883L11 4v5h5a1 1 0 0 1 .117 1.993L16 11h-5v5a1 1 0 0 1-1.993.117L9 16v-5H4a1 1 0 0 1-.117-1.993L4 9h5V4a1 1 0 0 1 1-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAdd_default = createIcon(SvgIcAdd);
function SvgIcAdmin(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 18,
            height: 18,
            x: 1,
            y: 1,
            fill: "#FB0",
            opacity: 0.2,
            rx: 6
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FFB600",
            fillRule: "evenodd",
            d: "M10.468 6.248a.5.5 0 0 0-.936 0L7.72 11.08 5.916 8.374A.5.5 0 0 0 5 8.65V13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V8.65a.5.5 0 0 0-.916-.277L12.28 11.08l-1.812-4.832Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcAdmin_default = createIcon(SvgIcAdmin);
function SvgIcAlbum(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#999",
          fillRule: "evenodd",
          d: "M2.222 3.222a1 1 0 0 1 1-1h13.556a1 1 0 0 1 1 1v13.556a1 1 0 0 1-1 1H3.222a1 1 0 0 1-1-1V3.222Zm5.185 5.482a1.296 1.296 0 1 0 0-2.593 1.296 1.296 0 0 0 0 2.593Zm7.926 7.13H4.167l3.16-3.689a1 1 0 0 1 1.491-.031L10 13.38l3.092-3.704a1 1 0 0 1 1.57.044l.974 1.31a1 1 0 0 1 .197.596v3.706a.5.5 0 0 1-.5.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAlbum_default = createIcon(SvgIcAlbum);
function SvgIcAlert(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM9 6.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v4.6a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2V6.2Zm2 6.8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcAlert_default = createIcon(SvgIcAlert);
function SvgIcBell(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8092AA",
          fillRule: "evenodd",
          d: "M8.211 20.598c1.155.667 2.623.416 3.72-.51.284-.24.242-.667-.045-.832l-4.35-2.512c-.287-.165-.678.012-.743.378-.254 1.413.264 2.81 1.418 3.476ZM14.559 3.094c.586-.234 1.138.01 1.49.214.354.204.84.56.932 1.184.044.301-.025.553-.09.718a2.09 2.09 0 0 1-.098.21c1.724 1.732 2.35 4.35 1.113 6.491l-.855 1.482c-.434.75-.49 1.71-.077 2.658l.002.006c.247.578.245 1.247-.086 1.821-.633 1.097-2.014 1.232-2.966.683l-10.02-5.786c-.953-.55-1.525-1.813-.892-2.91.33-.57.906-.91 1.526-.984h.006c1.036-.118 1.84-.647 2.272-1.397l.856-1.482C8.908 3.86 11.487 3.093 13.85 3.72c.036-.058.081-.125.132-.189.11-.14.294-.325.577-.437Zm-.107 2.982-.535-.225c-1.85-.778-3.74-.188-4.513 1.151l-.856 1.482c-.78 1.352-2.174 2.2-3.773 2.383a.17.17 0 0 0-.022.004l.003.01a.32.32 0 0 0 .148.162l10.02 5.786a.32.32 0 0 0 .215.046l.009-.002a.203.203 0 0 0-.01-.028c-.638-1.47-.6-3.101.18-4.452l.856-1.482c.773-1.34.339-3.272-1.26-4.484l-.462-.351Zm.718 10.788-.002.002.002-.002ZM4.75 10.848v.003-.003Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcBell_default = createIcon(SvgIcBell);
function SvgIcCalendar(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M5 3a1 1 0 0 1 2 0v1h6V3a1 1 0 1 1 2 0v1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2V3Zm2 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3-3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCalendar_default = createIcon(SvgIcCalendar);
function SvgIcCamera(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#02B585",
          fillRule: "evenodd",
          d: "M7 3a1 1 0 0 0-1 1v1h8V4a1 1 0 0 0-1-1H7ZM5 6a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3H5Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8.5 3.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0Zm-5.5 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCamera_default = createIcon(SvgIcCamera);
function SvgIcCancel(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#CCC" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M6.142 7.342a.2.2 0 0 1 0-.283l.917-.917a.2.2 0 0 1 .283 0l2.664 2.664 2.664-2.664a.2.2 0 0 1 .283 0l.917.917a.2.2 0 0 1 0 .283l-2.664 2.664 2.653 2.653a.2.2 0 0 1 0 .283l-.917.917a.2.2 0 0 1-.283 0l-2.653-2.653-2.653 2.653a.2.2 0 0 1-.283 0l-.917-.917a.2.2 0 0 1 0-.283l2.653-2.653-2.664-2.664Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcCancel_default = createIcon(SvgIcCancel);
function SvgIcCheckActive(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 12,
            cy: 12,
            r: 9,
            fill: "#02B585",
            stroke: "#333",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m8 11 4 4L22 5"
          }
        )
      ]
    }
  );
}
var IcCheckActive_default = createIcon(SvgIcCheckActive);
function SvgIcCheckDefault(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 9, stroke: "#999", strokeWidth: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#999",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m8 11 4 4L22 5"
          }
        )
      ]
    }
  );
}
var IcCheckDefault_default = createIcon(SvgIcCheckDefault);
function SvgIcCheck(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M15.288 5.298a1 1 0 0 1 1.506 1.31l-.082.094-7.895 8a1 1 0 0 1-1.338.078l-.094-.087-4.106-4.266a1 1 0 0 1 1.349-1.472l.093.085 3.393 3.527 7.174-7.27Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCheck_default = createIcon(SvgIcCheck);
function SvgIcCheckbox(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M5 2h9.75a3 3 0 0 1 3 3v9.75a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3ZM1 5a4 4 0 0 1 4-4h9.75a4 4 0 0 1 4 4v9.75a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V5Zm13.653 2.104a.5.5 0 0 0-.707-.708L8.3 12.043 5.653 9.396a.5.5 0 1 0-.707.708l3 3a.5.5 0 0 0 .707 0l6-6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCheckbox_default = createIcon(SvgIcCheckbox);
function SvgIcChecklist(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 11.667,
            height: 11.667,
            x: 3.75,
            y: 4.167,
            fill: "#555",
            opacity: 0.2,
            rx: 5.833
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M9.583 1.125a8.875 8.875 0 1 0 7.35 3.899l2.905-2.905a.542.542 0 0 0-.766-.766l-2.807 2.806a8.854 8.854 0 0 0-6.682-3.034Zm5.914 3.802a7.792 7.792 0 1 0 .653.879l-6.312 6.313a.542.542 0 0 1-.777-.012L5.855 8.705a.542.542 0 0 1 .789-.743l2.823 2.996 6.03-6.03Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcChecklist_default = createIcon(SvgIcChecklist);
function SvgIcClose(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "m4.613 3.21.094.083L10 8.585l5.293-5.292a1 1 0 0 1 1.497 1.32l-.083.094L11.415 10l5.292 5.293a1 1 0 0 1-1.32 1.497l-.094-.083L10 11.415l-5.293 5.292a1 1 0 0 1-1.497-1.32l.083-.094L8.585 10 3.293 4.707A1 1 0 0 1 4.51 3.14l.102.07Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcClose_default = createIcon(SvgIcClose);
function SvgIcCompleted(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 14.5,
            height: 14.5,
            x: 2.75,
            y: 2.75,
            stroke: "#333",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            rx: 2.25
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#3299FE",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "m6.5 9.75 2.146 2.146a.5.5 0 0 0 .708 0L13.5 7.75"
          }
        )
      ]
    }
  );
}
var IcCompleted_default = createIcon(SvgIcCompleted);
function SvgIcCopy(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#999",
          fillRule: "evenodd",
          d: "M16.244 4.856A1.75 1.75 0 0 0 14.5 3.25h-6l-.144.006A1.75 1.75 0 0 0 6.75 5v.75h1.5V5l.007-.057A.25.25 0 0 1 8.5 4.75h6l.057.007A.25.25 0 0 1 14.75 5v7l-.007.057a.25.25 0 0 1-.243.193h-.25v1.5h.25l.143-.006A1.75 1.75 0 0 0 16.25 12V5l-.006-.144ZM11.75 6.25a1.75 1.75 0 0 1 1.744 1.606L13.5 8v7a1.75 1.75 0 0 1-1.607 1.744l-.143.006h-6a1.75 1.75 0 0 1-1.744-1.607L4 15V8a1.75 1.75 0 0 1 1.606-1.744l.144-.006h6Zm0 1.5h-6a.25.25 0 0 0-.243.193L5.5 8v7a.25.25 0 0 0 .193.243l.057.007h6a.25.25 0 0 0 .243-.193L12 15V8a.25.25 0 0 0-.193-.243l-.057-.007Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcCopy_default = createIcon(SvgIcCopy);
function SvgIcCrew(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 18, height: 18, x: 1, y: 1, fill: "#F7F9FD", rx: 4 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            fillRule: "evenodd",
            d: "M10 8.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-.833 1A3.667 3.667 0 0 0 5.5 13.167C5.5 14.179 6.32 15 7.333 15h5.334c1.012 0 1.833-.82 1.833-1.833A3.667 3.667 0 0 0 10.833 9.5H9.167Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcCrew_default = createIcon(SvgIcCrew);
function SvgIcDelete(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CCC",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM6.142 7.059a.2.2 0 0 0 0 .283l2.664 2.664-2.653 2.653a.2.2 0 0 0 0 .283l.917.917a.2.2 0 0 0 .283 0l2.653-2.653 2.653 2.653a.2.2 0 0 0 .283 0l.917-.917a.2.2 0 0 0 0-.283l-2.653-2.653 2.664-2.664a.2.2 0 0 0 0-.283l-.917-.917a.2.2 0 0 0-.283 0l-2.664 2.664-2.664-2.664a.2.2 0 0 0-.283 0l-.917.917Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDelete_default = createIcon(SvgIcDelete);
function SvgIcDownArrowSolid(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#999",
          fillRule: "evenodd",
          d: "M3.04 3.5a.5.5 0 0 0-.39.812l2.96 3.7c.2.25.58.25.78 0l2.96-3.7a.5.5 0 0 0-.39-.812H3.04Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownArrowSolid_default = createIcon(SvgIcDownArrowSolid);
function SvgIcDownArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M3.267 6.27a.906.906 0 0 1 1.19-.089l.102.09L10 11.77l5.441-5.5a.906.906 0 0 1 1.19-.09l.102.09a.93.93 0 0 1 .088 1.201l-.088.104-6.087 6.154a.906.906 0 0 1-1.19.089l-.102-.09-6.087-6.153a.93.93 0 0 1 0-1.306Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownArrow_default = createIcon(SvgIcDownArrow);
function SvgIcDownload(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M15 16a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h10ZM10 2a1 1 0 0 1 1 1v8.585l3.293-3.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 .083 1.32l-.083.094-5 5a1 1 0 0 1-1.32.083l-.094-.083-5-5a1 1 0 0 1 1.32-1.497l.094.083L9 11.585V3a1 1 0 0 1 1-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDownload_default = createIcon(SvgIcDownload);
function SvgIcDrag(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CDD6E4",
          fillRule: "evenodd",
          d: "M0 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDrag_default = createIcon(SvgIcDrag);
function SvgIcDrawer(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm1 5a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2H4Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcDrawer_default = createIcon(SvgIcDrawer);
function SvgIcEdit(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "m15.65 3.447.89.893c.296.298.46.695.46 1.117 0 .421-.164.818-.46 1.116l-1.091 1.094-3.116-3.126 1.09-1.094c.595-.596 1.631-.596 2.226 0ZM3.943 13.05l7.716-7.716 3.007 3.007-7.717 7.715a.304.304 0 0 1-.14.08l-3.433.856a.303.303 0 0 1-.368-.368l.855-3.433a.307.307 0 0 1 .08-.14Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcEdit_default = createIcon(SvgIcEdit);
function SvgIcEmail(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M2 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5Zm1.5 2.65V15a.5.5 0 0 0 .41.492L4 15.5h12a.5.5 0 0 0 .492-.41L16.5 15V7.728l-6.134 3.427a.75.75 0 0 1-.637.044l-.101-.048L3.5 7.65Zm0-1.728 6.505 3.716L16.5 6.01V5a.5.5 0 0 0-.41-.492L16 4.5H4a.5.5 0 0 0-.492.41L3.5 5v.922Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcEmail_default = createIcon(SvgIcEmail);
function SvgIcError(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M10 4a1.41 1.41 0 0 0-1.406 1.497l.344 5.505a1.064 1.064 0 0 0 2.124 0l.345-5.505A1.41 1.41 0 0 0 10 4Zm0 11.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcError_default = createIcon(SvgIcError);
function SvgIcExcel(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 14.5,
            height: 14.5,
            x: 2.75,
            y: 2.75,
            stroke: "#555",
            strokeWidth: 1.5,
            rx: 3.25
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#555", d: "M4 6h12v2H4zM4 11h12v2H4z" }),
        /* @__PURE__ */ jsx("path", { fill: "#555", d: "M9 4v12H7V4z" })
      ]
    }
  );
}
var IcExcel_default = createIcon(SvgIcExcel);
function SvgIcFilter(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          d: "M4.33 6 8 11.311v6.174c0 .41.447.655.781.428l2.772-1.218c.28-.19.447-.512.447-.855V11.31L15.67 6H4.33ZM3.64 5h12.72l.928-1.344c.51-.675.04-1.656-.794-1.656H3.506c-.834 0-1.305.98-.794 1.656L3.64 5Z"
        }
      )
    }
  );
}
var IcFilter_default = createIcon(SvgIcFilter);
function SvgIcFinger(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M15.575 8.5h9.175a2.25 2.25 0 0 1 0 4.5h-2.967a2.25 2.25 0 0 1-1.211 3.061 2.25 2.25 0 0 1-.975 3.406 2.25 2.25 0 0 1-1.847 3.535h-9.5a2.25 2.25 0 0 1-2.235-2.51A2.528 2.528 0 0 1 6 20.216v-9.331a2.09 2.09 0 0 1 .992-2.125l9.114-5.441a2.088 2.088 0 1 1 2.14 3.586L15.577 8.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "m15.575 8.5-.384-.644-2.335 1.394h2.72V8.5Zm6.208 4.5v-.75h-1.188l.51 1.073.678-.323Zm-1.211 3.062-.274-.699-.903.355.57.785.607-.441Zm-.975 3.406-.283-.695-.87.354.538.77.615-.43ZM6.015 20.492l.745.086.01-.084-.01-.084-.745.082ZM6 10.892l-.75-.001H6Zm0-.007.75.001v-.06l-.01-.06-.74.12Zm.992-2.125.384.644-.384-.644Zm9.114-5.441-.385-.644.385.644ZM19 4.094l-.655.365.655-.365Zm-.753 2.811-.385-.644.385.644Zm6.503.845h-9.175v1.5h9.175v-1.5Zm3 3a3 3 0 0 0-3-3v1.5a1.5 1.5 0 0 1 1.5 1.5h1.5Zm-3 3a3 3 0 0 0 3-3h-1.5a1.5 1.5 0 0 1-1.5 1.5v1.5Zm-2.967 0h2.967v-1.5h-2.967v1.5Zm.967.216c0-.46-.104-.897-.29-1.288l-1.355.645c.093.194.145.412.145.643h1.5Zm-1.904 2.794a3 3 0 0 0 1.904-2.794h-1.5a1.5 1.5 0 0 1-.952 1.398l.548 1.396Zm.904.623a2.99 2.99 0 0 0-.572-1.762l-1.213.882c.18.247.285.55.285.88h1.5Zm-1.87 2.78a3 3 0 0 0 1.87-2.78h-1.5a1.5 1.5 0 0 1-.936 1.39l.565 1.39Zm-.898-.266c.169.242.268.537.268.856h1.5a2.99 2.99 0 0 0-.538-1.714l-1.23.858Zm.268.856a1.5 1.5 0 0 1-1.5 1.5v1.5a3 3 0 0 0 3-3h-1.5Zm-1.5 1.5h-9.5v1.5h9.5v-1.5Zm-9.5 0a1.5 1.5 0 0 1-1.5-1.5h-1.5a3 3 0 0 0 3 3v-1.5Zm-1.5-1.5c0-.06.003-.118.01-.175l-1.49-.172c-.013.114-.02.23-.02.347h1.5Zm-1.5-.537c0 .12.007.24.02.358l1.49-.164a1.777 1.777 0 0 1-.01-.194h-1.5Zm0-2.833v2.833h1.5v-2.833h-1.5Zm0-3.417v3.417h1.5v-3.417h-1.5Zm0-3.074v3.074h1.5v-3.074h-1.5Zm0-.008v.007l1.5.002v-.007l-1.5-.002Zm1.357-2.768a2.84 2.84 0 0 0-1.347 2.888l1.48-.238a1.34 1.34 0 0 1 .636-1.362l-.769-1.288Zm9.114-5.441L6.607 8.116l.77 1.288 9.113-5.441-.769-1.288Zm3.934 1.053a2.839 2.839 0 0 0-3.934-1.053l.769 1.288a1.339 1.339 0 0 1 1.855.496l1.31-.73ZM18.63 7.55a2.839 2.839 0 0 0 1.024-3.82l-1.31.73c.353.633.14 1.43-.483 1.802l.77 1.288ZM15.96 9.144 18.63 7.55l-.769-1.288-2.671 1.595.769 1.288Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 4, height: 14, y: 9, fill: "#333", rx: 1 })
      ]
    }
  );
}
var IcFinger_default = createIcon(SvgIcFinger);
function SvgIcGradeBadge(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M13.675 3.32a.2.2 0 0 0-.35 0L12.29 5.212a.2.2 0 0 1-.08.08l-1.89 1.034a.2.2 0 0 0 0 .35l1.89 1.034a.2.2 0 0 1 .08.08l1.034 1.89a.2.2 0 0 0 .35 0l1.034-1.89a.2.2 0 0 1 .08-.08l1.89-1.034a.2.2 0 0 0 0-.35L14.79 5.29a.2.2 0 0 1-.08-.08l-1.034-1.89Zm-5.5 4a.2.2 0 0 0-.35 0L6.26 10.18a.2.2 0 0 1-.08.08l-2.86 1.565a.2.2 0 0 0 0 .35l2.86 1.565a.2.2 0 0 1 .08.08l1.565 2.86a.2.2 0 0 0 .35 0l1.565-2.86a.2.2 0 0 1 .08-.08l2.86-1.565a.2.2 0 0 0 0-.35L9.82 10.26a.2.2 0 0 1-.08-.08L8.175 7.32Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcGradeBadge_default = createIcon(SvgIcGradeBadge);
function SvgIcHelpCenter(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#02B585",
            fillRule: "evenodd",
            d: "M10 3c2.835 0 5.2 2.137 5.833 5h.667a3 3 0 1 1 0 6h-.434c-.623 1.29-2.324 2.2-4.358 2.39-.273.37-.713.61-1.208.61h-1a1.5 1.5 0 0 1 0-3h1a1.5 1.5 0 0 1 1.396.95c1.3-.183 2.324-.716 2.77-1.35V9.537c0-2.862-2.099-5.166-4.666-5.166-2.505 0-4.564 2.193-4.663 4.958l-.004.208V14H3.5a3 3 0 1 1 0-6h.667C4.8 5.137 7.165 3 10 3Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 11.8, cy: 9.887, r: 0.9, fill: "#02B585" }),
        /* @__PURE__ */ jsx("circle", { cx: 8.2, cy: 9.887, r: 0.9, fill: "#02B585" })
      ]
    }
  );
}
var IcHelpCenter_default = createIcon(SvgIcHelpCenter);
function SvgIcHelp(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#CCC",
          fillRule: "evenodd",
          d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.913-5.665v-.663c0-.468.026-.494.481-.897.845-.741 1.443-1.287 1.443-2.431 0-1.443-1.209-2.6-2.769-2.6-2.236 0-2.86 2.119-2.86 2.119l1.326.611s.416-1.248 1.534-1.248c.65 0 1.209.507 1.209 1.118 0 .611-.26.858-.741 1.274l-.238.203c-.669.568-.932.792-.932 1.552v.962h1.547Zm-.767 2.821a1.02 1.02 0 0 0 1.027-1.027 1.02 1.02 0 0 0-1.027-1.027 1.02 1.02 0 0 0-1.027 1.027 1.02 1.02 0 0 0 1.027 1.027Z",
          clipRule: "evenodd",
          opacity: 0.8
        }
      )
    }
  );
}
var IcHelp_default = createIcon(SvgIcHelp);
function SvgIcHome(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "m14.555 4.189 7.554 5.66c.557.416.891 1.118.891 1.87v10.034c0 1.24-.895 2.247-2 2.247h-4a1 1 0 0 1-1-1v-4.619c0-1.24-.895-2.247-2-2.247-1.054 0-1.918.917-1.995 2.08L12 18.38V23a1 1 0 0 1-1 1H7c-1.105 0-2-1.006-2-2.247V11.718c0-.751.334-1.453.89-1.87l7.555-5.66a.91.91 0 0 1 1.11 0ZM14 6.272l-6.91 5.177c-.033.024-.07.095-.085.192L7 11.718v10.035c0 .052.005.095.01.13l.013.078c.003.018.002.03-.006.035L7 22h3l.001-3.684.009-.233c.143-2.175 1.835-3.949 3.99-3.949 2.196 0 3.894 1.834 3.995 4.04l.005.207V22h3c-.019 0-.025-.007-.025-.024l.022-.151.003-.072V11.718a.436.436 0 0 0-.065-.242l-.025-.027L14 6.272Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcHome_default = createIcon(SvgIcHome);
function SvgIcInfoMedium(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm1 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-3 2.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v3.75h.25a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1 0-1.5h.75v-3h-.75a.75.75 0 0 1-.75-.75Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcInfoMedium_default = createIcon(SvgIcInfoMedium);
function SvgIcInfo(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            fillRule: "evenodd",
            d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-.5 6h-1v-1H9v-3h-.5V9h2a.5.5 0 0 1 .5.5V13h.5v1h-2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcInfo_default = createIcon(SvgIcInfo);
function SvgIcIssue(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 14.5,
            height: 14.5,
            x: 2.75,
            y: 2.75,
            stroke: "#333",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            rx: 2.25
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 2, fill: "#F66" })
      ]
    }
  );
}
var IcIssue_default = createIcon(SvgIcIssue);
function SvgIcIssues(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M13.766 7.643a1 1 0 0 0-1.532-1.286l-3.491 4.156-2.029-2.07a1 1 0 1 0-1.428 1.4l2.607 2.66a1.25 1.25 0 0 0 1.85-.07l4.023-4.79ZM16.5 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm-11 6a1 1 0 1 0 0 2h17a1 1 0 1 0 0-2h-17Zm-1 7a1 1 0 0 1 1-1h17a1 1 0 1 1 0 2h-17a1 1 0 0 1-1-1Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcIssues_default = createIcon(SvgIcIssues);
function SvgIcLanguage(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8092AA",
          fillRule: "evenodd",
          stroke: "#8092AA",
          strokeWidth: 0.4,
          d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm1.248-.746a7.743 7.743 0 0 1 1.26-3.558c.8.138 1.625.252 2.473.341a16.202 16.202 0 0 0-.443 3.217h-3.29Zm4.088-4.4A37.97 37.97 0 0 1 6.38 6.61a7.793 7.793 0 0 1 3.184-2.008c-.392.467-.718 1.03-.983 1.637a9.966 9.966 0 0 0-.245.617Zm.416 4.4c.049-1.128.208-2.183.452-3.106a43.382 43.382 0 0 0 5.607.059c.236.91.389 1.943.437 3.047H8.752Zm3.714-4.197c.664 0 1.318-.015 1.962-.045C13.83 5.494 12.964 4.54 12 4.54c-.953 0-1.81.933-2.407 2.421.934.064 1.894.097 2.873.097Zm3.996 4.197a16.28 16.28 0 0 0-.422-3.131 40.65 40.65 0 0 0 2.539-.292 7.739 7.739 0 0 1 1.173 3.423h-3.29Zm-.77-4.32a39.415 39.415 0 0 0 2.037-.209 7.793 7.793 0 0 0-3.293-2.124c.392.467.717 1.03.983 1.637.097.222.188.455.273.697ZM6.376 17.388a7.79 7.79 0 0 0 3.188 2.012c-.392-.467-.718-1.03-.983-1.637a9.913 9.913 0 0 1-.247-.621c-.668.067-1.322.149-1.958.246Zm-.87-1.087a7.745 7.745 0 0 1-1.28-3.834H7.53c.032 1.244.188 2.43.45 3.493-.847.089-1.673.203-2.473.34Zm4.085.736c.597 1.49 1.455 2.425 2.409 2.425.965 0 1.832-.956 2.43-2.477a42.634 42.634 0 0 0-4.839.052Zm5.221-1.247a43.76 43.76 0 0 0-5.61.059 14.975 14.975 0 0 1-.46-3.382h6.516a15.04 15.04 0 0 1-.446 3.323Zm.881 1.272c-.085.244-.177.477-.274.7-.266.608-.591 1.17-.983 1.638a7.794 7.794 0 0 0 3.297-2.128 39.33 39.33 0 0 0-2.04-.21Zm2.888-.896a39.831 39.831 0 0 0-2.54-.292c.25-1.04.4-2.196.43-3.407h3.303a7.744 7.744 0 0 1-1.193 3.699Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcLanguage_default = createIcon(SvgIcLanguage);
function SvgIcLeftArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M13.73 3.267a.906.906 0 0 1 .089 1.19l-.09.102L8.23 10l5.5 5.441a.906.906 0 0 1 .09 1.19l-.09.102a.93.93 0 0 1-1.201.088l-.104-.088-6.154-6.087a.906.906 0 0 1-.089-1.19l.09-.102 6.153-6.087a.93.93 0 0 1 1.306 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcLeftArrow_default = createIcon(SvgIcLeftArrow);
function SvgIcLink(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            d: "M10.584 8.142c.293.168.309.565.07.804-.207.207-.532.219-.797.096a2.267 2.267 0 0 0-2.557.453L4.686 12.11a2.266 2.266 0 0 0 3.205 3.206L9.904 13.3a.567.567 0 0 1 .801.802l-2.013 2.013a3.4 3.4 0 1 1-4.808-4.808l2.614-2.614a3.4 3.4 0 0 1 4.086-.552Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            d: "M9.677 11.334c-.294-.167-.309-.565-.07-.804.207-.206.532-.218.797-.095.838.389 1.865.237 2.557-.454l2.614-2.614a2.266 2.266 0 0 0-3.205-3.205l-2.013 2.013a.567.567 0 0 1-.802-.801L11.57 3.36a3.4 3.4 0 1 1 4.807 4.807l-2.614 2.614a3.401 3.401 0 0 1-4.085.552Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            fillRule: "evenodd",
            d: "M11.411 3.203a3.622 3.622 0 0 1 5.122 5.122L13.92 10.94a3.623 3.623 0 0 1-4.352.588c-.448-.255-.437-.833-.117-1.154.292-.292.725-.29 1.047-.14a2.045 2.045 0 0 0 2.307-.41l2.614-2.613a2.044 2.044 0 1 0-2.891-2.891l-2.013 2.013a.789.789 0 1 1-1.116-1.116l2.013-2.013Zm4.808.315a3.177 3.177 0 0 0-4.493 0L9.713 5.53a.344.344 0 0 0 .487.487l2.013-2.013a2.489 2.489 0 0 1 3.519 3.519l-2.614 2.614a2.49 2.49 0 0 1-2.808.498c-.208-.096-.424-.07-.546.051-.158.158-.117.374.023.454a3.179 3.179 0 0 0 3.818-.516l2.614-2.614a3.177 3.177 0 0 0 0-4.493ZM6.341 8.537a3.623 3.623 0 0 1 4.353-.588c.447.255.437.834.116 1.154-.291.292-.725.29-1.047.14a2.045 2.045 0 0 0-2.306.41l-2.614 2.614a2.044 2.044 0 1 0 2.89 2.89l2.014-2.013a.789.789 0 0 1 1.115 1.116L8.85 16.273a3.622 3.622 0 1 1-5.122-5.122l2.614-2.614Zm4.133-.202a3.179 3.179 0 0 0-3.818.516l-2.614 2.614a3.177 3.177 0 0 0 4.493 4.494l2.013-2.013a.344.344 0 1 0-.487-.487l-2.013 2.013a2.489 2.489 0 0 1-3.52-3.52l2.615-2.614A2.49 2.49 0 0 1 9.95 8.84c.207.097.424.07.545-.05.158-.159.118-.375-.022-.455Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcLink_default = createIcon(SvgIcLink);
function SvgIcListEdit(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 7, height: 16, x: 12, y: 2, fill: "#EAEAEA", rx: 3.5 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#777",
            fillRule: "evenodd",
            d: "m13 13 2.5 3 2.5-3h-5ZM13 7l2.5-3L18 7h-5ZM1 4h9v2H1V4Zm0 5h9v2H1V9Zm9 5H1v2h9v-2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { stroke: "#CCC", strokeLinecap: "square", d: "M14 10h3" })
      ]
    }
  );
}
var IcListEdit_default = createIcon(SvgIcListEdit);
function SvgIcLogout(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M8 2a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-1h-2v1a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1h2V6a4 4 0 0 0-4-4H8Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M20.968 12.733a.97.97 0 0 0 0-1.466L18.8 9.39a.97.97 0 0 0-1.604.733v3.756a.97.97 0 0 0 1.604.733l2.168-1.878Z"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 6, height: 2, x: 12, y: 11, fill: "#333", rx: 0.5 })
      ]
    }
  );
}
var IcLogout_default = createIcon(SvgIcLogout);
function SvgIcMemo(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#C1E7DD",
            fillRule: "evenodd",
            d: "M7.333.667H16a2 2 0 0 1 2 2v14.666a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6L7.333.667Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#02B585",
            fillRule: "evenodd",
            d: "M6 7.833a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.334a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-.333ZM6 10.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.334a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5V10.5Zm.5 2.167a.5.5 0 0 0-.5.5v.333a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.333a.5.5 0 0 0-.5-.5h-7ZM2 6h5.333V.667",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcMemo_default = createIcon(SvgIcMemo);
function SvgIcMenu(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M6 9a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H7Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMenu_default = createIcon(SvgIcMenu);
function SvgIcMobileview(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#555",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M16 10.635v5.519c0 1.02-.768 1.846-1.714 1.846H5.714C4.768 18 4 17.173 4 16.154V3.846C4 2.826 4.768 2 5.714 2h2.429"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#999",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M12 2h5v5"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 9,
            height: 2,
            x: 9.757,
            y: 7.828,
            fill: "#999",
            rx: 1,
            transform: "rotate(-45 9.757 7.828)"
          }
        )
      ]
    }
  );
}
var IcMobileview_default = createIcon(SvgIcMobileview);
function SvgIcMore(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#999",
          fillRule: "evenodd",
          d: "M11.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM10 16.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcMore_default = createIcon(SvgIcMore);
function SvgIcNewBell(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 17.5, cy: 9.5, r: 2.5, fill: "#F66" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#8092AA",
            fillRule: "evenodd",
            d: "M8.211 20.598c1.155.667 2.623.416 3.72-.51.284-.24.242-.667-.045-.832l-4.35-2.512c-.287-.165-.678.012-.743.378-.254 1.413.264 2.81 1.418 3.476ZM16.05 3.308c-.353-.204-.905-.448-1.491-.214a1.397 1.397 0 0 0-.577.437c-.05.064-.096.13-.132.189-2.363-.627-4.942.14-6.178 2.282l-.856 1.482c-.433.75-1.236 1.279-2.272 1.397h-.006a2.021 2.021 0 0 0-1.526.985c-.633 1.096-.06 2.36.892 2.91l10.02 5.785c.952.55 2.333.414 2.966-.683.331-.574.333-1.244.086-1.82l-.002-.007c-.317-.727-.357-1.462-.163-2.103a4.474 4.474 0 0 1-1.863-.741c-.4 1.163-.324 2.453.19 3.638.005.011.008.02.01.028l-.01.002a.32.32 0 0 1-.214-.046l-10.02-5.786a.32.32 0 0 1-.148-.162l-.003-.01a.17.17 0 0 1 .022-.004c1.599-.183 2.993-1.031 3.773-2.383l.856-1.482c.773-1.34 2.663-1.93 4.513-1.151l.535.225.068.052a4.482 4.482 0 0 1 2.429-1.095c.039-.148.062-.333.032-.541-.091-.624-.578-.98-.931-1.184Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcNewBell_default = createIcon(SvgIcNewBell);
function SvgIcNewIssue(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#D9F4ED",
            fillRule: "evenodd",
            d: "M2.5 7a4.5 4.5 0 0 0 4.303-5.82A11.953 11.953 0 0 1 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12c0-1.862.424-3.624 1.18-5.197A4.5 4.5 0 0 0 2.5 7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 2.5, cy: 2.5, r: 2.5, fill: "#F66" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#61CBB5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m9 11.6 2.25 2.4L15 10"
          }
        )
      ]
    }
  );
}
var IcNewIssue_default = createIcon(SvgIcNewIssue);
function SvgIcNewReport(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#D9F4ED",
            fillRule: "evenodd",
            d: "M2.5 7a4.5 4.5 0 0 0 4.303-5.82A11.953 11.953 0 0 1 12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12c0-1.862.424-3.624 1.18-5.197A4.5 4.5 0 0 0 2.5 7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 2.5, cy: 2.5, r: 2.5, fill: "#F66" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#61CBB5",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M10 10h4M10 13h4"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#61CBB5",
            fillRule: "evenodd",
            d: "M5.25 8A2.75 2.75 0 0 1 8 5.25h8A2.75 2.75 0 0 1 18.75 8v8A2.75 2.75 0 0 1 16 18.75H8A2.75 2.75 0 0 1 5.25 16V8ZM8 6.75c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25H8Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcNewReport_default = createIcon(SvgIcNewReport);
function SvgIcNewTab(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M17.5 3.5a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h2.586L9.429 9.157a1 1 0 1 0 1.414 1.414L15.5 5.914V8.5a1 1 0 0 0 2 0v-5Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M4.5 3.5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3a1 1 0 1 0-2 0v3h-10v-10h3a1 1 0 0 0 0-2h-3Z"
          }
        )
      ]
    }
  );
}
var IcNewTab_default = createIcon(SvgIcNewTab);
function SvgIcNext(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M12.425 3.283a.5.5 0 0 0-.708 0l-.707.707a.5.5 0 0 0 0 .707L15.314 9H1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h13.814l-4.304 4.303a.5.5 0 0 0 0 .708l.707.707a.5.5 0 0 0 .708 0l6.364-6.364a.5.5 0 0 0 0-.707l-6.364-6.364Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcNext_default = createIcon(SvgIcNext);
function SvgIcNoticeLine(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, stroke: "#333", strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-.5 6h-1v-1H9v-3h-.5V9h2a.5.5 0 0 1 .5.5V13h.5v1h-2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcNoticeLine_default = createIcon(SvgIcNoticeLine);
function SvgIcNotice(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#EAEAEA" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#999",
            fillRule: "evenodd",
            d: "M10 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-.5 6h-1v-1H9v-3h-.5V9h2a.5.5 0 0 1 .5.5V13h.5v1h-2Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcNotice_default = createIcon(SvgIcNotice);
function SvgIcOverview(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 15,
            x: 4,
            y: 5,
            stroke: "#333",
            strokeWidth: 2,
            rx: 3
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 3, x: 15, y: 2.5, fill: "#333", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 3, x: 7, y: 2.5, fill: "#333", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m8.5 12.3 2.625 2.7 4.375-4.5"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#333", d: "M5 8a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2H5Z" })
      ]
    }
  );
}
var IcOverview_default = createIcon(SvgIcOverview);
function SvgIcPassword(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M13.5 5.23C13.5 3.446 12.029 2 10.214 2h-.428C7.97 2 6.5 3.446 6.5 5.23V8"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeWidth: 1.5,
            d: "M3.25 11A2.25 2.25 0 0 1 5.5 8.75h9A2.25 2.25 0 0 1 16.75 11v6c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25v-6Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M7.75 13.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm3 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcPassword_default = createIcon(SvgIcPassword);
function SvgIcPhone(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeWidth: 1.5,
            d: "M4.75 4A2.25 2.25 0 0 1 7 1.75h6A2.25 2.25 0 0 1 15.25 4v12A2.25 2.25 0 0 1 13 18.25H7A2.25 2.25 0 0 1 4.75 16V4Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { stroke: "#333", strokeLinecap: "round", strokeWidth: 1.5, d: "M9 16h2" })
      ]
    }
  );
}
var IcPhone_default = createIcon(SvgIcPhone);
function SvgIcPlace(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M14 2c5.524 0 10 4.507 10 10.063 0 5.08-3 9.617-8.877 13.586-.554.374-1.253.444-1.91.174l-.164-.075-.179-.108-.38-.263C6.931 21.474 4.064 17.032 4 12.063 4 6.108 8.273 2 14 2Zm0 2c-4.64 0-8 3.23-8 8.05.054 4.135 2.444 7.937 7.267 11.425l.366.261.313.22.056.036.371-.254c4.876-3.388 7.38-7.07 7.61-11.066l.013-.308.004-.301C22 7.608 18.417 4 14 4Zm0 4.286c2.22 0 4 1.865 4 4.143 0 2.278-1.78 4.143-4 4.143-2.22 0-4-1.865-4-4.143 0-2.278 1.78-4.143 4-4.143Zm0 2c-1.094 0-2 .95-2 2.143 0 1.194.906 2.143 2 2.143 1.094 0 2-.95 2-2.143 0-1.194-.906-2.143-2-2.143Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcPlace_default = createIcon(SvgIcPlace);
function SvgIcQrcode(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M16 2a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2H16Zm-.5 1.5a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1h2.5ZM7.5 10.5a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3.5a2 2 0 0 1 2-2h3.5ZM7 12a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1H4.5a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1H7ZM7.5 2a2 2 0 0 1 2 2v3.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3.5ZM7 3.5a1 1 0 0 1 1 1V7a1 1 0 0 1-1 1H4.5a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1H7Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#555", d: "M7 4.5H4.5V7H7z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M16 10.5a2 2 0 0 1 2 2V16a2 2 0 0 1-2 2h-3.5a2 2 0 0 1-2-2v-3.5a2 2 0 0 1 2-2H16Zm-.5 1.5a1 1 0 0 1 1 1v2.5a1 1 0 0 1-1 1H13a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1h2.5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#555", d: "M15.5 13H13v2.5h2.5z" })
      ]
    }
  );
}
var IcQrcode_default = createIcon(SvgIcQrcode);
function SvgIcRadio(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M5.833 10a4.167 4.167 0 1 1 8.333 0 4.167 4.167 0 0 1-8.333 0Z",
            opacity: 0.2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M10 5.292a4.708 4.708 0 1 0 0 9.416 4.708 4.708 0 0 0 0-9.416ZM6.375 10a3.625 3.625 0 1 1 7.25 0 3.625 3.625 0 0 1-7.25 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M10 1.125a8.875 8.875 0 1 0 0 17.75 8.875 8.875 0 0 0 0-17.75ZM2.208 10a7.792 7.792 0 1 1 15.583 0 7.792 7.792 0 0 1-15.583 0Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcRadio_default = createIcon(SvgIcRadio);
function SvgIcReadChecklist(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "#F4F4F4", rx: 12 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 12,
            height: 12,
            x: 6,
            y: 6,
            stroke: "#CCC",
            strokeWidth: 1.5,
            rx: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#CCC",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "m9 11.6 2.25 2.4L15 10"
          }
        )
      ]
    }
  );
}
var IcReadChecklist_default = createIcon(SvgIcReadChecklist);
function SvgIcReadIssue(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "#F4F4F4", rx: 12 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#CCC",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M13 10.5h4M7 13.5h10M7 16.5h10M7 8.786l1.403 1.503a.25.25 0 0 0 .378-.015L11 7.5"
          }
        )
      ]
    }
  );
}
var IcReadIssue_default = createIcon(SvgIcReadIssue);
function SvgIcReadReport(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 24, height: 24, fill: "#F4F4F4", rx: 12 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#CCC",
            strokeLinecap: "round",
            strokeWidth: 1.5,
            d: "M10 10h4M10 13h4"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 12,
            height: 12,
            x: 6,
            y: 6,
            stroke: "#CCC",
            strokeWidth: 1.5,
            rx: 2
          }
        )
      ]
    }
  );
}
var IcReadReport_default = createIcon(SvgIcReadReport);
function SvgIcRefresh(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M15.133 5.243a7 7 0 1 0 1.536 6.89.473.473 0 0 0-.351-.599l-1.115-.27a.224.224 0 0 0-.27.16 5.133 5.133 0 1 1-.973-4.691H11.9a.5.5 0 0 0-.5.5V8.1a.5.5 0 0 0 .5.5h4.6a.5.5 0 0 0 .5-.5V3.5a.5.5 0 0 0-.5-.5h-.867a.5.5 0 0 0-.5.5v1.743Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcRefresh_default = createIcon(SvgIcRefresh);
function SvgIcRemove(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 8, fill: "#FF7979" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M5 10a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcRemove_default = createIcon(SvgIcRemove);
function SvgIcRightArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M6.27 16.733a.906.906 0 0 1-.089-1.19l.09-.102L11.77 10l-5.5-5.441a.906.906 0 0 1-.09-1.19l.09-.102a.93.93 0 0 1 1.201-.088l.104.088 6.154 6.087a.906.906 0 0 1 .089 1.19l-.09.102-6.153 6.087a.93.93 0 0 1-1.306 0Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcRightArrow_default = createIcon(SvgIcRightArrow);
function SvgIcSearch(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 9, cy: 9, r: 7, stroke: "#555", strokeWidth: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#555",
            strokeLinecap: "round",
            strokeWidth: 2,
            d: "m14.5 14.5 4 4"
          }
        )
      ]
    }
  );
}
var IcSearch_default = createIcon(SvgIcSearch);
function SvgIcSection(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M15.833 1.875H4.167a2.292 2.292 0 0 0-2.292 2.292v2.5a2.292 2.292 0 0 0 2.292 2.291h11.666a2.292 2.292 0 0 0 2.292-2.291v-2.5a2.292 2.292 0 0 0-2.292-2.292ZM4.167 3.125h11.666c.576 0 1.042.466 1.042 1.042v2.5c0 .575-.466 1.041-1.042 1.041H4.167a1.042 1.042 0 0 1-1.042-1.041v-2.5c0-.576.466-1.042 1.042-1.042Zm11.666 7.917H4.167a2.292 2.292 0 0 0-2.292 2.291v2.5a2.292 2.292 0 0 0 2.292 2.292h11.666a2.292 2.292 0 0 0 2.292-2.292v-2.5a2.292 2.292 0 0 0-2.292-2.291Zm-11.666 1.25h11.666c.576 0 1.042.466 1.042 1.041v2.5c0 .576-.466 1.042-1.042 1.042H4.167a1.042 1.042 0 0 1-1.042-1.042v-2.5c0-.575.466-1.041 1.042-1.041Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSection_default = createIcon(SvgIcSection);
function SvgIcSettingFill(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#999",
          fillRule: "evenodd",
          d: "M10.405 17h-.81a.913.913 0 0 1-.899-.75l-.117-.646a5.707 5.707 0 0 1-1.535-.638l-.542.375a.932.932 0 0 1-1.165-.105l-.573-.573a.913.913 0 0 1-.105-1.165l.375-.542a5.716 5.716 0 0 1-.638-1.535l-.646-.117a.913.913 0 0 1-.75-.899v-.81c0-.442.315-.82.75-.898l.646-.118c.136-.539.35-1.053.638-1.535l-.375-.542a.913.913 0 0 1 .105-1.165l.573-.573a.931.931 0 0 1 1.165-.105l.542.375a5.711 5.711 0 0 1 1.535-.638l.117-.646A.913.913 0 0 1 9.595 3h.81c.441 0 .82.315.899.75l.117.646c.539.136 1.053.35 1.535.638l.542-.375a.931.931 0 0 1 1.165.105l.573.573a.912.912 0 0 1 .105 1.165l-.375.542c.288.482.502.996.638 1.535l.646.117c.435.08.75.457.75.899v.81c0 .442-.315.82-.75.898l-.646.118a5.725 5.725 0 0 1-.638 1.535l.375.542a.912.912 0 0 1-.105 1.165l-.573.573a.907.907 0 0 1-1.165.105l-.542-.375a5.71 5.71 0 0 1-1.535.638l-.117.646a.913.913 0 0 1-.899.75ZM10 8c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSettingFill_default = createIcon(SvgIcSettingFill);
function SvgIcSetting(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M14.637 2c1.12 0 2.088.763 2.36 1.836l.035.163.074.408.168.054c.262.09.52.191.773.303l.378.175.159.083.344-.238a2.469 2.469 0 0 1 2.824.04l.15.117.133.124.9.9c.79.788.936 2.003.38 2.952l-.1.156-.237.342.083.161c.122.25.234.503.335.76l.143.39.053.167.409.075a2.434 2.434 0 0 1 1.975 2.056l.018.173.006.166v1.274a2.434 2.434 0 0 1-1.836 2.36l-.163.035-.409.073-.053.169c-.09.262-.191.52-.303.773l-.175.377-.084.16.239.343a2.434 2.434 0 0 1-.035 2.822l-.12.151-.126.135-.9.9a2.426 2.426 0 0 1-1.722.713c-.434 0-.856-.115-1.229-.333l-.156-.1-.344-.238-.159.083c-.249.123-.503.235-.76.335l-.39.144-.169.053-.074.409a2.435 2.435 0 0 1-2.056 1.975l-.173.018-.166.006h-1.274a2.435 2.435 0 0 1-2.36-1.836L10.968 24l-.075-.408-.167-.053a9.965 9.965 0 0 1-.773-.303l-.378-.175-.16-.084-.344.24a2.47 2.47 0 0 1-2.823-.04l-.15-.118-.133-.124-.9-.9a2.435 2.435 0 0 1-.38-2.952l.1-.156.236-.343-.082-.16a9.972 9.972 0 0 1-.335-.761l-.143-.39-.054-.167-.408-.074a2.435 2.435 0 0 1-1.975-2.056l-.018-.173L2 14.637v-1.274c0-1.121.763-2.09 1.836-2.36L4 10.969l.407-.074.054-.167c.09-.262.19-.52.302-.773l.176-.378.082-.161-.237-.343A2.435 2.435 0 0 1 4.82 6.25l.12-.15.125-.136.9-.9a2.466 2.466 0 0 1 2.954-.378l.154.098.342.237.16-.082c.25-.123.503-.235.76-.335l.39-.144.168-.054.075-.408a2.436 2.436 0 0 1 2.056-1.975l.173-.018.166-.006h1.274Zm0 2h-1.274a.435.435 0 0 0-.407.282l-.02.075-.3 1.648-.623.158a7.96 7.96 0 0 0-1.853.726l-.291.166-.553.33-1.381-.956a.471.471 0 0 0-.49-.001l-.066.051-.9.9a.434.434 0 0 0-.093.478l.043.077.956 1.38-.33.554a7.998 7.998 0 0 0-.788 1.771l-.104.373-.157.624-1.65.3a.433.433 0 0 0-.35.35L4 13.363v1.274c0 .184.115.344.282.407l.075.02 1.649.3.157.624c.163.644.406 1.264.725 1.853l.167.291.33.553-.956 1.38a.435.435 0 0 0-.006.487l.056.069.9.9c.117.117.325.15.481.09l.074-.04 1.382-.957.553.331a7.984 7.984 0 0 0 1.823.804l.32.088.625.158.298 1.647c.034.182.175.32.351.351l.077.007h1.274a.434.434 0 0 0 .407-.282l.02-.075.3-1.648.624-.158a7.96 7.96 0 0 0 1.853-.726l.29-.166.554-.33 1.38.956a.43.43 0 0 0 .49.005l.066-.055.9-.9a.434.434 0 0 0 .093-.477l-.043-.078-.956-1.38.33-.554a8.015 8.015 0 0 0 .788-1.771l.104-.374.158-.623 1.648-.3a.433.433 0 0 0 .35-.35l.007-.077v-1.274a.434.434 0 0 0-.282-.407l-.074-.02-1.649-.3-.158-.623a7.968 7.968 0 0 0-.699-1.805l-.193-.34-.33-.553.956-1.38a.434.434 0 0 0 .006-.487l-.055-.069-.901-.9a.47.47 0 0 0-.481-.09l-.074.04-1.38.957-.554-.331a8.001 8.001 0 0 0-1.771-.788l-.373-.104-.624-.158-.3-1.648a.435.435 0 0 0-.35-.35L14.637 4ZM14 10c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4Zm0 2c-1.102 0-2 .898-2 2 0 1.102.898 2 2 2 1.102 0 2-.898 2-2 0-1.102-.898-2-2-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSetting_default = createIcon(SvgIcSetting);
function SvgIcSheet(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 15a3 3 0 0 1 2.995 2.824L13 18v3a3 3 0 0 1-2.824 2.995L10 24H7a3 3 0 0 1-2.995-2.824L4 21v-3a3 3 0 0 1 2.824-2.995L7 15h3Zm11 0a3 3 0 0 1 2.995 2.824L24 18v3a3 3 0 0 1-2.824 2.995L21 24h-3a3 3 0 0 1-2.995-2.824L15 21v-3a3 3 0 0 1 2.824-2.995L18 15h3Zm-11 2H7a1 1 0 0 0-.993.883L6 18v3a1 1 0 0 0 .883.993L7 22h3a1 1 0 0 0 .993-.883L11 21v-3a1 1 0 0 0-.883-.993L10 17Zm11 0h-3a1 1 0 0 0-.993.883L17 18v3a1 1 0 0 0 .883.993L18 22h3a1 1 0 0 0 .993-.883L22 21v-3a1 1 0 0 0-.883-.993L21 17ZM10 4a3 3 0 0 1 2.995 2.824L13 7v3a3 3 0 0 1-2.824 2.995L10 13H7a3 3 0 0 1-2.995-2.824L4 10V7a3 3 0 0 1 2.824-2.995L7 4h3Zm11 0a3 3 0 0 1 2.995 2.824L24 7v3a3 3 0 0 1-2.824 2.995L21 13h-3a3 3 0 0 1-2.995-2.824L15 10V7a3 3 0 0 1 2.824-2.995L18 4h3ZM10 6H7a1 1 0 0 0-.993.883L6 7v3a1 1 0 0 0 .883.993L7 11h3a1 1 0 0 0 .993-.883L11 10V7a1 1 0 0 0-.883-.993L10 6Zm11 0h-3a1 1 0 0 0-.993.883L17 7v3a1 1 0 0 0 .883.993L18 11h3a1 1 0 0 0 .993-.883L22 10V7a1 1 0 0 0-.883-.993L21 6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcSheet_default = createIcon(SvgIcSheet);
function SvgIcSlider(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 15.556,
            height: 1.667,
            x: 2.222,
            y: 3.611,
            fill: "#555",
            rx: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 15.556,
            height: 1.667,
            x: 2.222,
            y: 9.166,
            fill: "#555",
            rx: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 15.556,
            height: 1.667,
            x: 2.222,
            y: 14.722,
            fill: "#555",
            rx: 0.5
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M8.333 4.444a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M6.667 3.611a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Zm-2.5.833a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M15 10a1.667 1.667 0 1 1-3.334 0A1.667 1.667 0 0 1 15 10Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M13.334 9.167a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666Zm-2.5.833a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            d: "M9.445 15.555a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M7.778 14.722a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Zm-2.5.834a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcSlider_default = createIcon(SvgIcSlider);
function SvgIcStatisticActive(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 3.5,
            height: 12.5,
            x: 3.75,
            y: 7.75,
            fill: "#02B585",
            stroke: "#333",
            strokeWidth: 1.5,
            rx: 1.75
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 3.5,
            height: 10.5,
            x: 10.25,
            y: 9.75,
            fill: "#02B585",
            stroke: "#333",
            strokeWidth: 1.5,
            rx: 1.75
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 3.5,
            height: 16.5,
            x: 16.75,
            y: 3.75,
            fill: "#02B585",
            stroke: "#333",
            strokeWidth: 1.5,
            rx: 1.75
          }
        )
      ]
    }
  );
}
var IcStatisticActive_default = createIcon(SvgIcStatisticActive);
function SvgIcStatisticDefault(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#999",
          fillRule: "evenodd",
          d: "M19.5 5.5v13a1 1 0 1 1-2 0v-13a1 1 0 1 1 2 0Zm-3.5 0a2.5 2.5 0 0 1 5 0v13a2.5 2.5 0 0 1-5 0v-13Zm-9.5 13v-9a1 1 0 0 0-2 0v9a1 1 0 1 0 2 0ZM5.5 7A2.5 2.5 0 0 0 3 9.5v9a2.5 2.5 0 0 0 5 0v-9A2.5 2.5 0 0 0 5.5 7ZM13 18.5v-7a1 1 0 1 0-2 0v7a1 1 0 1 0 2 0ZM12 9a2.5 2.5 0 0 0-2.5 2.5v7a2.5 2.5 0 0 0 5 0v-7A2.5 2.5 0 0 0 12 9Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcStatisticDefault_default = createIcon(SvgIcStatisticDefault);
function SvgIcStatistics(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M17 12a1 1 0 1 1 2 0v7.8a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V12ZM9 15a1 1 0 1 1 2 0v4.8a.2.2 0 0 1-.2.2H9.2a.2.2 0 0 1-.2-.2V15ZM5 17a1 1 0 1 1 2 0v2.8a.2.2 0 0 1-.2.2H5.2a.2.2 0 0 1-.2-.2V17ZM13 16a1 1 0 1 1 2 0v3.8a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V16Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M20.494 4.155a1 1 0 0 0-.992-1.141l-2.96.005a1 1 0 0 0-.753 1.656l.507.584-4.062 3.53-1.98-2.277a1.089 1.089 0 0 0-1.536-.107L4.05 10.463a1 1 0 0 0-.099 1.411l.117.134a1 1 0 0 0 1.41.1l3.848-3.345 1.98 2.277a1.089 1.089 0 0 0 1.536.108l4.884-4.246.607.698a1 1 0 0 0 1.744-.515l.418-2.93Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcStatistics_default = createIcon(SvgIcStatistics);
function SvgIcText(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M1.125 5A3.875 3.875 0 0 1 5 1.125h10A3.875 3.875 0 0 1 18.875 5v10a3.875 3.875 0 0 1-3.876 3.875H5A3.875 3.875 0 0 1 1.126 15V5ZM5 2.208A2.792 2.792 0 0 0 2.208 5v10A2.792 2.792 0 0 0 5 17.792h10A2.792 2.792 0 0 0 17.79 15V5A2.792 2.792 0 0 0 15 2.208H5Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M11.666 5h.833v10h-.833V5ZM4.166 5.833V7.5h2.5v6.667h1.667V7.5h2.5V5.833H4.166Z"
          }
        )
      ]
    }
  );
}
var IcText_default = createIcon(SvgIcText);
function SvgIcTime(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#8092AA",
          fillRule: "evenodd",
          d: "M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Zm.743 3.398A.75.75 0 0 0 9.25 7v3.6l.007.104a.75.75 0 0 0 .167.376l2 2.4.077.08a.75.75 0 0 0 .98.016l.08-.077a.75.75 0 0 0 .015-.98l-1.826-2.191V7l-.007-.102Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcTime_default = createIcon(SvgIcTime);
function SvgIcTrash(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M7.6 4a1 1 0 0 1 1-1h2.8a1 1 0 0 1 1 1h3.19a.91.91 0 0 1 .91.91v.18a.91.91 0 0 1-.91.91H4.41a.91.91 0 0 1-.91-.91v-.18A.91.91 0 0 1 4.41 4H7.6ZM5.082 7a.96.96 0 0 0-.953 1.074l.906 7.552A1.56 1.56 0 0 0 6.584 17h6.832c.79 0 1.455-.59 1.549-1.374l.906-7.552A.96.96 0 0 0 14.918 7H5.082ZM8.1 9a.6.6 0 0 0-.6.6v4.8a.6.6 0 0 0 .6.6h.3a.6.6 0 0 0 .6-.6V9.6a.6.6 0 0 0-.6-.6h-.3Zm2.9.6a.6.6 0 0 1 .6-.6h.3a.6.6 0 0 1 .6.6v4.8a.6.6 0 0 1-.6.6h-.3a.6.6 0 0 1-.6-.6V9.6Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcTrash_default = createIcon(SvgIcTrash);
function SvgIcTutorialCompleted(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 10, cy: 10, r: 9, fill: "#02B585" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m5 9.5 3.75 3.75L15 7"
          }
        )
      ]
    }
  );
}
var IcTutorialCompleted_default = createIcon(SvgIcTutorialCompleted);
function SvgIcTutorial(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 14, cy: 14, r: 11, stroke: "#333", strokeWidth: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M15.266 16.167v.942h-2.199v-1.367c0-1.081.374-1.399 1.324-2.206l.339-.288c.683-.592 1.053-.943 1.053-1.811s-.794-1.59-1.718-1.59c-1.59 0-2.18 1.775-2.18 1.775L10 10.753s.887-3.011 4.065-3.011c2.217 0 3.935 1.644 3.935 3.695 0 1.626-.85 2.402-2.05 3.455-.647.573-.684.61-.684 1.275Zm.37 3.491a1.45 1.45 0 0 1-1.46 1.46 1.45 1.45 0 0 1-1.46-1.46c0-.812.647-1.459 1.46-1.459.812 0 1.46.647 1.46 1.46Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcTutorial_default = createIcon(SvgIcTutorial);
function SvgIcUpArrowSolid(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 12 12",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#999",
          fillRule: "evenodd",
          d: "M8.96 8.5a.5.5 0 0 0 .39-.812l-2.96-3.7a.5.5 0 0 0-.78 0l-2.96 3.7a.5.5 0 0 0 .39.812h5.92Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcUpArrowSolid_default = createIcon(SvgIcUpArrowSolid);
function SvgIcUpArrow(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M16.733 13.73a.906.906 0 0 1-1.19.089l-.102-.09L10 8.23l-5.441 5.5a.906.906 0 0 1-1.19.09l-.102-.09a.93.93 0 0 1-.088-1.201l.088-.104L9.354 6.27a.906.906 0 0 1 1.19-.089l.102.09 6.087 6.153a.93.93 0 0 1 0 1.306Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcUpArrow_default = createIcon(SvgIcUpArrow);
function SvgIcUser(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M10 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Zm0 1.5a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Zm7.746 12.03A5.75 5.75 0 0 0 12 10.25H8l-.22.004A5.75 5.75 0 0 0 2.25 16v1l.007.102A.75.75 0 0 0 3.75 17v-1l.005-.206A4.25 4.25 0 0 1 8 11.75h4l.206.005A4.25 4.25 0 0 1 16.25 16v1l.007.102A.75.75 0 0 0 17.75 17v-1l-.004-.22Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcUser_default = createIcon(SvgIcUser);
function SvgIcViewOff(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M15.835 4.167a.561.561 0 0 0-.8 0l-2.293 2.316a6.315 6.315 0 0 0-2.959-.77c-3.997 0-6.588 4.088-6.696 4.262a.576.576 0 0 0 0 .607 11.33 11.33 0 0 0 2.746 2.879l-1.537 1.552a.574.574 0 0 0 .246.969c.2.052.412-.01.553-.162l10.74-10.846a.575.575 0 0 0 0-.807Zm-8.313 6.112a2.272 2.272 0 0 1 2.261-2.284 2.18 2.18 0 0 1 1.137.328l-3.073 3.104a2.24 2.24 0 0 1-.325-1.148ZM14.971 8c.738.636 1.39 1.36 1.939 2.153a.55.55 0 0 1 0 .605C16.796 10.93 14.088 15 9.91 15A6.538 6.538 0 0 1 8 14.703L14.97 8Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcViewOff_default = createIcon(SvgIcViewOff);
function SvgIcViewOn(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#555",
          fillRule: "evenodd",
          d: "M10 5c-3.182 0-5.9 2.073-7 5 1.1 2.927 3.818 5 7 5s5.9-2.073 7-5c-1.1-2.927-3.818-5-7-5Zm0 8.333c-1.756 0-3.182-1.493-3.182-3.333S8.244 6.667 10 6.667 13.182 8.16 13.182 10 11.756 13.333 10 13.333ZM10 8c-1.056 0-1.91.893-1.91 2s.854 2 1.91 2 1.91-.893 1.91-2-.854-2-1.91-2Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcViewOn_default = createIcon(SvgIcViewOn);
function SvgIcWorker(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 28 28",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#333",
          fillRule: "evenodd",
          d: "M14 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm4.207 9c2.604 0 4.81 1.92 5.168 4.5l.309 2.225A2 2 0 0 1 21.703 24H6.297a2 2 0 0 1-1.981-2.275l.309-2.225A5.218 5.218 0 0 1 9.793 15h8.414Zm.184 2.005L18.207 17H9.793a3.218 3.218 0 0 0-3.157 2.593l-.03.182L6.296 22h15.407l-.31-2.225a3.218 3.218 0 0 0-3.002-2.77Z",
          clipRule: "evenodd"
        }
      )
    }
  );
}
var IcWorker_default = createIcon(SvgIcWorker);
function SvgIcYesno(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M16.864 3.126a4.984 4.984 0 0 1 1.47 3.54v6.667a5 5 0 0 1-5 5H6.667a4.984 4.984 0 0 1-3.521-1.45",
            clipRule: "evenodd",
            opacity: 0.2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            d: "M5.416 4.722a.542.542 0 1 0-.833.694l1.958 2.35v2.303a.542.542 0 0 0 1.084 0V7.765l1.957-2.349a.542.542 0 1 0-.832-.694L7.083 6.723l-1.667-2ZM15.958 11.127a.542.542 0 0 0-1.084 0v2.736l-2.495-3.018c-.423-.511-1.255-.212-1.255.451v3.89a.542.542 0 1 0 1.084 0v-2.848l2.496 3.018c.423.512 1.254.213 1.254-.451v-3.778Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#555",
            fillRule: "evenodd",
            d: "M6.666 1.125a5.542 5.542 0 0 0-5.541 5.542v6.666c0 1.335.472 2.56 1.258 3.517l-.683.684a.542.542 0 0 0 .766.766l.683-.684a5.519 5.519 0 0 0 3.517 1.259h6.667a5.542 5.542 0 0 0 5.542-5.542V6.667a5.52 5.52 0 0 0-1.26-3.517l.684-.684a.542.542 0 0 0-.766-.766l-.683.684a5.519 5.519 0 0 0-3.517-1.259H6.666Zm9.413 2.03a4.439 4.439 0 0 0-2.746-.947H6.666a4.458 4.458 0 0 0-4.458 4.459v6.666c0 1.036.353 1.99.946 2.747L16.079 3.154ZM3.92 16.844a4.44 4.44 0 0 0 2.747.947h6.667a4.458 4.458 0 0 0 4.458-4.459V6.667a4.44 4.44 0 0 0-.946-2.747L3.92 16.846Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var IcYesno_default = createIcon(SvgIcYesno);
function SvgEnglish(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#02B585",
          d: "M26.566 22.454c-.564 0-.846-.302-.846-.906v-2.242c0-.604.282-.906.846-.906.563 0 .834.3.838.9v2.248c0 .604-.28.906-.838.906Zm0 1.908c1.845 0 2.767-.939 2.767-2.815V14.53c0-1.872-.922-2.807-2.767-2.807-1.845 0-2.775.935-2.775 2.807v1.162h1.93V14.53c0-.6.279-.902.838-.906h.014c.554 0 .831.302.831.906v2.39c-.381-.286-.879-.429-1.492-.429-1.414.005-2.12.943-2.12 2.815v2.241c0 1.872.925 2.81 2.774 2.815Zm-7.049-1.908c-.559 0-.838-.302-.838-.906v-7.011c0-.604.281-.907.845-.907.563 0 .834.3.838.9v7.017c0 .604-.282.906-.845.906Zm0 1.908c1.85-.005 2.774-.943 2.774-2.815V7.6h-1.929v4.552c-.381-.286-.88-.43-1.493-.43-1.413.005-2.12.943-2.12 2.815v7.01c0 1.877.923 2.815 2.768 2.815Zm-7.035-1.908c-.563 0-.845-.302-.845-.906v-2.242c0-.604.282-.906.845-.906.564 0 .834.3.839.9v2.248c0 .604-.28.906-.839.906Zm0 1.908c1.845 0 2.768-.939 2.768-2.815V14.53c0-1.872-.923-2.807-2.768-2.807-1.845 0-2.774.935-2.774 2.807v1.162h1.93V14.53c0-.6.279-.902.838-.906h.013c.555 0 .832.302.832.906v2.39c-.381-.286-.88-.429-1.493-.429-1.413.005-2.12.943-2.12 2.815v2.241c0 1.872.925 2.81 2.775 2.815Zm-7.887-.218V14.53c.005-.6.284-.9.839-.9.554 0 .845.303.845.907v9.606h1.929v-9.606c0-1.872-.707-2.81-2.12-2.815-.613 0-1.111.143-1.493.43V7.6H2.667v16.544h1.929Z"
        }
      )
    }
  );
}
var English_default = createIcon(SvgEnglish);
function SvgKorean(props) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 32",
      ...props,
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#02B585",
          d: "M27.613 25.51h-2.151V7.395h2.15v8.194h1.721v2.157h-1.72v7.763ZM6.537 12.14h-.43a.861.861 0 0 0-.858.798l-.002.064v9.273c0 .455.351.827.796.86l.064.002h.43a.861.861 0 0 0 .858-.798l.003-.064v-9.273a.862.862 0 0 0-.796-.86l-.065-.002Zm17.205-4.097v2.156H20.3a.646.646 0 0 0-.642.585l-.003.062v11.213c0 .336.256.613.583.644l.062.003h3.44v2.157h-3.44a2.8 2.8 0 0 1-2.794-2.703l-.002-.1V10.845a2.8 2.8 0 0 1 2.696-2.802l.1-.001h3.44ZM7.398 6.533v1.725h2.58v2.157H8.09a3.02 3.02 0 0 1 1.46 2.587v9.273a3.015 3.015 0 0 1-3.011 3.019h-.43a3.015 3.015 0 0 1-3.011-3.02v-9.272c0-1.098.585-2.059 1.459-2.587h-1.89V8.258h2.581V6.533h2.151Zm6.451.863v8.194h1.72v2.157h-1.72v7.763H11.7V7.396h2.15Z"
        }
      )
    }
  );
}
var Korean_default = createIcon(SvgKorean);
function SvgImgAlert(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 60 60",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FEF4C2",
            d: "M23.11 7.96c3.078-5.28 10.702-5.28 13.78 0l21.011 36.037C61.003 49.318 57.168 56 51.011 56H8.989c-6.157 0-9.992-6.682-6.89-12.003L23.109 7.96Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#FB0",
            fillRule: "evenodd",
            d: "M29 26a1 1 0 0 0-1 1v9a2 2 0 1 0 4 0v-9a1 1 0 0 0-1-1h-2Zm1 18.667a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            clipRule: "evenodd"
          }
        )
      ]
    }
  );
}
var ImgAlert_default = createIcon(SvgImgAlert);
function SvgImgAssignees(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-assignees_svg__a)" }),
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 9, fill: "#C8D5E9" }),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: 20,
            cy: 14.5,
            r: 3.5,
            fill: "#fff",
            stroke: "#333",
            strokeWidth: 2
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            stroke: "#333",
            strokeWidth: 2,
            d: "M13 26.25c0-2.9 2.35-5.25 5.25-5.25h3.5c2.9 0 5.25 2.35 5.25 5.25A1.75 1.75 0 0 1 25.25 28h-10.5A1.75 1.75 0 0 1 13 26.25Z"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-assignees_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F1F4F6" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D9E1E6" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgAssignees_default = createIcon(SvgImgAssignees);
function SvgImgAverage(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-average_svg__a)" }),
        /* @__PURE__ */ jsx("rect", { width: 15, height: 15, x: 15.334, y: 15, fill: "#61CBB5", rx: 3 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 16,
            x: 10,
            y: 10,
            fill: "#fff",
            stroke: "#333",
            strokeWidth: 2,
            rx: 3
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M14.5 15a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0v-5a1 1 0 0 1 1-1ZM18 14a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1ZM21.5 16a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-average_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F1FAF7" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E2EDEF" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgAverage_default = createIcon(SvgImgAverage);
function SvgImgCheckedFacility(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-checked-facility_svg__a)" }),
        /* @__PURE__ */ jsx("ellipse", { cx: 20, cy: 31, fill: "#61CBB5", rx: 6, ry: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            stroke: "#333",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M20 10c-4.64 0-8 3.232-8 8.053.054 4.137 2.444 7.94 7.267 11.43l.366.26.313.22.056.037.371-.254c4.876-3.39 7.38-7.073 7.61-11.07l.013-.308.004-.302C28 13.61 24.417 10 20 10Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m16.5 19 2.625 3 4.375-5"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-checked-facility_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F1FAF7" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E2EDEF" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgCheckedFacility_default = createIcon(SvgImgCheckedFacility);
function SvgImgChecklist(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-checklist_svg__a)" }),
        /* @__PURE__ */ jsx("rect", { width: 15, height: 15, x: 15.666, y: 15, fill: "#61CBB5", rx: 3 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 16,
            x: 10,
            y: 10,
            fill: "#fff",
            stroke: "#333",
            strokeWidth: 2,
            rx: 3
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m14 17.4 3 3.6 5-6"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-checklist_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F1FAF7" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E2EDEF" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgChecklist_default = createIcon(SvgImgChecklist);
function SvgImgFacility(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-facility_svg__a)" }),
        /* @__PURE__ */ jsx("ellipse", { cx: 20, cy: 31, fill: "#61CBB5", rx: 6, ry: 2 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#fff",
            fillRule: "evenodd",
            stroke: "#333",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M20 10c-4.64 0-8 3.232-8 8.053.054 4.137 2.444 7.94 7.267 11.43l.366.26.313.22.056.037.371-.254c4.876-3.39 7.38-7.073 7.61-11.07l.013-.308.004-.302C28 13.61 24.417 10 20 10Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 18, r: 3, stroke: "#333", strokeWidth: 2 }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-facility_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F1FAF7" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E2EDEF" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgFacility_default = createIcon(SvgImgFacility);
function SvgImgPending(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-pending_svg__a)" }),
        /* @__PURE__ */ jsx("rect", { width: 15, height: 15, x: 15.334, y: 15, fill: "#FF7979", rx: 3 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 16,
            x: 10,
            y: 10,
            fill: "#fff",
            stroke: "#333",
            strokeWidth: 2,
            rx: 3
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            fillRule: "evenodd",
            d: "M15.5 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-pending_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#FAF1F1" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#EFE2E2" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgPending_default = createIcon(SvgImgPending);
function SvgImgResolved(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-resolved_svg__a)" }),
        /* @__PURE__ */ jsx("rect", { width: 15, height: 15, x: 15.334, y: 15, fill: "#3299FE", rx: 3 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 16,
            height: 16,
            x: 10,
            y: 10,
            fill: "#fff",
            stroke: "#333",
            strokeWidth: 2,
            rx: 3
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m14.5 17.8 2.625 2.7L21.5 16"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-resolved_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F1F6FA" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E2E7EF" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgResolved_default = createIcon(SvgImgResolved);
function SvgImgScheduled(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 40 40",
      ...props,
      children: [
        /* @__PURE__ */ jsx("circle", { cx: 20, cy: 20, r: 20, fill: "url(#img-scheduled_svg__a)" }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 17,
            height: 17,
            x: 11.5,
            y: 11.5,
            fill: "#fff",
            stroke: "#333",
            strokeWidth: 2,
            rx: 3
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 3, x: 23.5, y: 9, fill: "#333", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 2, height: 3, x: 14.5, y: 9, fill: "#333", rx: 1 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m16.5 20.8 2.625 2.7L23.5 19"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#61CBB5",
            d: "M12.5 14.5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v1h-15v-1Z"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-scheduled_svg__a",
            x1: 20,
            x2: 40,
            y1: 0,
            y2: 40,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#F1FAF7" }),
              /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#E2EDEF" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgScheduled_default = createIcon(SvgImgScheduled);
function SvgImgTutorial01(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 100 100",
      ...props,
      children: [
        /* @__PURE__ */ jsx("g", { filter: "url(#img-tutorial01_svg__a)", children: /* @__PURE__ */ jsx("rect", { width: 74, height: 70, x: 13.75, y: 11.5, fill: "#fff", rx: 6 }) }),
        /* @__PURE__ */ jsx("rect", { width: 41, height: 4, x: 38.75, y: 61.5, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 34, height: 4, x: 38.75, y: 67.5, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 13.8,
            height: 13.8,
            x: 20.35,
            y: 59.1,
            stroke: "#02B585",
            strokeWidth: 1.2,
            rx: 2.4
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.7,
            d: "m23.25 65.356 3.232 3.144 4.768-5"
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 41, height: 4, x: 38.75, y: 39.5, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 34, height: 4, x: 38.75, y: 46.5, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 13.8,
            height: 13.8,
            x: 20.35,
            y: 38.1,
            stroke: "#02B585",
            strokeWidth: 1.2,
            rx: 2.4
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.7,
            d: "m23.25 44.356 3.232 3.144 4.768-5"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 79.25, cy: 71.5, r: 17, fill: "#02B585" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M72.279 71.461h14M79.278 64.461v14"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#02B585",
            d: "M23.158 27.598c-1.836 0-2.959-1.314-2.959-3.633 0-2.32 1.123-3.633 2.96-3.633 1.835 0 2.963 1.323 2.958 3.633.005 2.324-1.123 3.633-2.959 3.633Zm-1.25-3.633c-.005 1.567.498 2.275 1.25 2.275s1.255-.708 1.25-2.275c0-1.543-.498-2.28-1.25-2.285-.747.005-1.245.742-1.25 2.285Zm7.94 3.633c-1.665 0-2.867-.86-2.862-2.012-.005-.879.699-1.592 1.592-1.729v-.048c-.781-.147-1.328-.787-1.328-1.563 0-1.108 1.099-1.914 2.598-1.914 1.489 0 2.587.81 2.587 1.914 0 .781-.561 1.416-1.328 1.563v.048c.88.137 1.592.85 1.592 1.729 0 1.152-1.201 2.012-2.851 2.012Zm-1.114-2.188c-.005.557.45.952 1.114.957.654-.005 1.103-.4 1.103-.957 0-.556-.469-.967-1.103-.967-.65 0-1.118.406-1.114.967Zm.147-2.988c-.005.513.4.879.967.879.556 0 .962-.366.957-.88.005-.502-.396-.858-.957-.858-.572 0-.972.356-.967.859Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#333",
            d: "M36.81 26.67a.877.877 0 0 1-.878-.889c-.01-.478.395-.869.878-.869.47 0 .884.39.89.87a.905.905 0 0 1-.89.888Zm-.878-4.541c-.01-.479.395-.87.878-.87.47 0 .884.391.89.87a.905.905 0 0 1-.89.889.877.877 0 0 1-.878-.89Zm7.988 5.469c-1.836 0-2.96-1.314-2.96-3.633 0-2.32 1.124-3.633 2.96-3.633 1.836 0 2.964 1.323 2.959 3.633.005 2.324-1.123 3.633-2.96 3.633Zm-1.25-3.633c-.005 1.567.498 2.275 1.25 2.275s1.255-.708 1.25-2.275c0-1.543-.498-2.28-1.25-2.285-.747.005-1.245.742-1.25 2.285Zm8.066 3.633c-1.836 0-2.959-1.314-2.959-3.633 0-2.32 1.123-3.633 2.96-3.633 1.835 0 2.963 1.323 2.958 3.633.005 2.324-1.123 3.633-2.959 3.633Zm-1.25-3.633c-.005 1.567.498 2.275 1.25 2.275s1.255-.708 1.25-2.275c0-1.543-.498-2.28-1.25-2.285-.747.005-1.245.742-1.25 2.285Z"
          }
        ),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "filter",
          {
            id: "img-tutorial01_svg__a",
            width: 94,
            height: 90,
            x: 3.75,
            y: 3.5,
            colorInterpolationFilters: "sRGB",
            filterUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  result: "hardAlpha",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", { dy: 2 }),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 5 }),
              /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.141176 0 0 0 0 0.454902 0 0 0 0 0.368627 0 0 0 0.2 0" }),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_1234_249"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_1234_249",
                  result: "shape"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}
var ImgTutorial01_default = createIcon(SvgImgTutorial01);
function SvgImgTutorial02(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 100 100",
      ...props,
      children: [
        /* @__PURE__ */ jsx("g", { filter: "url(#img-tutorial02_svg__a)", children: /* @__PURE__ */ jsx("rect", { width: 66, height: 22, x: 14, y: 14, fill: "#fff", rx: 3 }) }),
        /* @__PURE__ */ jsx("rect", { width: 37, height: 3, x: 36, y: 20, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 31, height: 3, x: 36, y: 26, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 13.8,
            height: 13.8,
            x: 18.6,
            y: 17.6,
            stroke: "#02B585",
            strokeWidth: 1.2,
            rx: 2.4
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#333",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.7,
            d: "M21.5 23.856 24.732 27l4.768-5"
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: 65,
            height: 22,
            x: 14.5,
            y: 43.5,
            fill: "#DFF9F2",
            stroke: "#92BBB0",
            strokeDasharray: 2.3,
            rx: 2.5
          }
        ),
        /* @__PURE__ */ jsx("rect", { width: 37, height: 3, x: 36, y: 50, fill: "#BDE2D8", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 31, height: 3, x: 36, y: 56, fill: "#BDE2D8", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 13, height: 13, x: 19, y: 48, fill: "#BDE2D8", rx: 3 }),
        /* @__PURE__ */ jsx("ellipse", { cx: 69.507, cy: 84.563, fill: "#A2D7C9", rx: 18.666, ry: 6.436 }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#02B585",
            fillRule: "evenodd",
            d: "M84.5 69.344c4.014-3.957 6.5-9.44 6.5-15.501C91 41.779 81.15 32 69 32s-22 9.78-22 21.843c0 6.228 2.625 11.847 6.837 15.826l12.196 13.736a4 4 0 0 0 5.982 0L84.5 69.345Z",
            clipRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx("circle", { cx: 69, cy: 53, r: 11, fill: "#fff" }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "filter",
          {
            id: "img-tutorial02_svg__a",
            width: 82,
            height: 38,
            x: 6,
            y: 8,
            colorInterpolationFilters: "sRGB",
            filterUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  result: "hardAlpha",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }
              ),
              /* @__PURE__ */ jsx("feOffset", { dy: 2 }),
              /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 4 }),
              /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.141176 0 0 0 0 0.454902 0 0 0 0 0.368627 0 0 0 0.2 0" }),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_1234_231"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_1234_231",
                  result: "shape"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}
var ImgTutorial02_default = createIcon(SvgImgTutorial02);
function SvgImgTutorial03(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 101 100",
      ...props,
      children: [
        /* @__PURE__ */ jsx("g", { filter: "url(#img-tutorial03_svg__a)", children: /* @__PURE__ */ jsx("rect", { width: 74, height: 74, x: 10, y: 9, fill: "#fff", rx: 6 }) }),
        /* @__PURE__ */ jsx("rect", { width: 26, height: 11, x: 19, y: 21, fill: "#D9F4ED", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 40, height: 11, x: 19, y: 35, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsx("rect", { width: 26, height: 3, x: 19, y: 54, fill: "#EBEEEF", rx: 1 }),
        /* @__PURE__ */ jsxs("g", { filter: "url(#img-tutorial03_svg__b)", children: [
          /* @__PURE__ */ jsx(
            "rect",
            {
              width: 29.947,
              height: 30.785,
              x: 57.976,
              y: 56.848,
              fill: "#fff",
              rx: 3
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#333",
              fillRule: "evenodd",
              d: "M62.254 61.177h7.29v7.376h-7.29v-7.376Zm1.215 6.147h4.86v-4.917h-4.86v4.917Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#333", d: "M64.684 63.636h2.43v2.459h-2.43z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#333",
              fillRule: "evenodd",
              d: "M76.832 68.553v-7.376h7.289v7.376h-7.289Zm1.215-1.23h4.859v-4.916h-4.86v4.917Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx("path", { fill: "#333", d: "M79.262 63.636h2.43v2.459h-2.43z" }),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#333",
              fillRule: "evenodd",
              d: "M69.543 83.304h-7.289V75.93h7.29v7.375Zm-1.215-6.146H63.47v4.917h4.86v-4.917Z",
              clipRule: "evenodd"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#333",
              d: "M64.684 78.387h2.43v2.459h-2.43zM72.58 61.177h3.037v1.229H72.58zM73.49 66.71h1.367v-1.435h1.367v-1.434h-4.1v-1.434h-1.367v2.868h2.734v1.434ZM70.757 66.709h1.215v1.229h-1.215zM76.224 67.938h-1.367v1.537h-4.1v1.536h5.467v-3.073ZM63.773 73.93h1.518v-1.382h-1.518v-2.766h-1.519v5.531h1.519V73.93ZM65.291 69.782h1.215v1.229h-1.215zM70.88 75.313h2.915V73.93h-1.458v-1.382H69.42v-2.766h-1.457v2.766h-1.458v2.765h1.458V73.93h2.915v1.383ZM74.402 71.626h1.215v3.073h-1.215zM75.13 75.929h-4.373v1.475h2.916v4.425h-2.916v1.475h4.374V81.83h2.915v-1.475h-2.915v-4.425Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#333",
              d: "M70.757 79.001h1.215v1.229h-1.215zM75.617 75.929h1.215v3.073h-1.215zM82.906 79.001h-4.252v4.303h1.418v-2.868h2.834V79Z"
            }
          ),
          /* @__PURE__ */ jsx(
            "path",
            {
              fill: "#333",
              d: "M81.084 82.075h3.037v1.229h-3.037zM82.906 76.543h1.215v1.229h-1.215zM78.35 77.772h1.519V73.47h-3.037v1.434h1.519v2.868ZM81.205 71.318h-1.457v-1.536H78.29v1.536h-1.458v1.537h5.831v-1.537h1.458v-1.536h-2.916v1.536ZM81.084 73.47h3.037v1.229h-3.037z"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-tutorial03_svg__c)",
            d: "M54.4 59a6 6 0 0 1 6-6h25.105a6 6 0 0 1 6 6v12.548H54.4V59Z",
            opacity: 0.803
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            stroke: "#02B585",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M62.563 53H59.4a5 5 0 0 0-5 5v3.26M62.563 91H59.4a5 5 0 0 1-5-5v-3.26M83.788 53h3.164a5 5 0 0 1 5 5v3.26M83.79 91h3.163a5 5 0 0 0 5-5v-3.26"
          }
        ),
        /* @__PURE__ */ jsx("path", { stroke: "#fff", strokeWidth: 1.2, d: "M54.176 71.321H91.73" }),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-tutorial03_svg__a",
              width: 94,
              height: 94,
              x: 0,
              y: 1,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 2 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 5 }),
                /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.141176 0 0 0 0 0.454902 0 0 0 0 0.368627 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_1234_211"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_1234_211",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "filter",
            {
              id: "img-tutorial03_svg__b",
              width: 49.948,
              height: 50.785,
              x: 47.976,
              y: 48.848,
              colorInterpolationFilters: "sRGB",
              filterUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                /* @__PURE__ */ jsx(
                  "feColorMatrix",
                  {
                    in: "SourceAlpha",
                    result: "hardAlpha",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  }
                ),
                /* @__PURE__ */ jsx("feOffset", { dy: 2 }),
                /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: 5 }),
                /* @__PURE__ */ jsx("feColorMatrix", { values: "0 0 0 0 0.141176 0 0 0 0 0.454902 0 0 0 0 0.368627 0 0 0 0.2 0" }),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_1234_211"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "feBlend",
                  {
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_1234_211",
                    result: "shape"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "img-tutorial03_svg__c",
              x1: 47.542,
              x2: 47.542,
              y1: 46.144,
              y2: 71.548,
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#02B585", stopOpacity: 0.33 }),
                /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#9EE1CF", stopOpacity: 0.288 })
              ]
            }
          )
        ] })
      ]
    }
  );
}
var ImgTutorial03_default = createIcon(SvgImgTutorial03);
function SvgImgUpgrade(props) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 48 48",
      ...props,
      children: [
        /* @__PURE__ */ jsx("rect", { width: 48, height: 48, fill: "#D8F2EB", opacity: 0.6, rx: 16 }),
        /* @__PURE__ */ jsx("path", { fill: "#8DE8D1", d: "M13 28.4h11v13l-11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#4DC9AA", d: "M35 28.4H24v13l11-4v-9Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#48CEAD", d: "M13.2 25.2 24 23.8v4.6l-10.8-3.2Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#8CEDD5", d: "M34.8 25.2 24 23.8v4.6l10.8-3.2Z" }),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "url(#img-upgrade_svg__a)",
            d: "M13 7.6h22l-5.6 20.8H18.6L13 7.6Z",
            opacity: 0.6
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: "#77D5BB",
            d: "M21.024 10.72a.2.2 0 0 1 .351 0l.928 1.697a.199.199 0 0 0 .08.08l1.696.927a.2.2 0 0 1 0 .351l-1.696.928a.199.199 0 0 0-.08.08l-.928 1.696a.2.2 0 0 1-.35 0l-.928-1.696a.199.199 0 0 0-.08-.08l-1.696-.928a.2.2 0 0 1 0-.35l1.696-.928a.199.199 0 0 0 .08-.08l.927-1.696ZM26.825 17.12a.2.2 0 0 1 .35 0l.645 1.18a.201.201 0 0 0 .08.08l1.18.644a.2.2 0 0 1 0 .351l-1.18.645a.201.201 0 0 0-.08.08l-.644 1.179a.2.2 0 0 1-.351 0l-.645-1.18a.201.201 0 0 0-.08-.079l-1.18-.645a.2.2 0 0 1 0-.35l1.18-.646a.201.201 0 0 0 .08-.08l.645-1.178Z"
          }
        ),
        /* @__PURE__ */ jsx("path", { fill: "#C8FEF0", d: "M13.2 25.2 24 28.4l-3.2 4-10.4-3.6 2.8-3.6Z" }),
        /* @__PURE__ */ jsx("path", { fill: "#A1F9E3", d: "M34.8 25.2 24 28.4l3.2 4 10.4-3.6-2.8-3.6Z" }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "linearGradient",
          {
            id: "img-upgrade_svg__a",
            x1: 24,
            x2: 24,
            y1: 7.6,
            y2: 28.4,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx("stop", { stopColor: "#64DFC0", stopOpacity: 0 }),
              /* @__PURE__ */ jsx("stop", { offset: 0.989, stopColor: "#64DFC0" })
            ]
          }
        ) })
      ]
    }
  );
}
var ImgUpgrade_default = createIcon(SvgImgUpgrade);

export { IcAdd_default as AddIcon, IcAdmin_default as AdminIcon, IcAlbum_default as AlbumIcon, IcAlert_default as AlertIcon, ImgAlert_default as AlertIllustration, ImgAssignees_default as AssigneesIllustration, ImgAverage_default as AverageIllustration, IcBell_default as BellIcon, IcCalendar_default as CalendarIcon, IcCamera_default as CameraIcon, IcCancel_default as CancelIcon, IcCheckActive_default as CheckActiveIcon, IcCheckDefault_default as CheckDefaultIcon, IcCheck_default as CheckIcon, IcCheckbox_default as CheckboxIcon, ImgCheckedFacility_default as CheckedFacilityIllustration, IcChecklist_default as ChecklistIcon, ImgChecklist_default as ChecklistIllustration, IcClose_default as CloseIcon, IcCompleted_default as CompletedIcon, IcCopy_default as CopyIcon, IcCrew_default as CrewIcon, IcDelete_default as DeleteIcon, IcDownArrow_default as DownArrowIcon, IcDownArrowSolid_default as DownArrowSolidIcon, IcDownload_default as DownloadIcon, IcDrag_default as DragIcon, IcDrawer_default as DrawerIcon, IcEdit_default as EditIcon, IcEmail_default as EmailIcon, English_default as EnglishIllustration, IcError_default as ErrorIcon, IcExcel_default as ExcelIcon, ImgFacility_default as FacilityIllustration, IcFilter_default as FilterIcon, IcFinger_default as FingerIcon, IcGradeBadge_default as GradeBadgeIcon, IcHelpCenter_default as HelpCenterIcon, IcHelp_default as HelpIcon, IcHome_default as HomeIcon, IcInfo_default as InfoIcon, IcInfoMedium_default as InfoMediumIcon, IcIssue_default as IssueIcon, IcIssues_default as IssuesIcon, Korean_default as KoreanIllustration, IcLanguage_default as LanguageIcon, IcLeftArrow_default as LeftArrowIcon, IcLink_default as LinkIcon, IcListEdit_default as ListEditIcon, IcLogout_default as LogoutIcon, IcMemo_default as MemoIcon, IcMenu_default as MenuIcon, IcMobileview_default as MobileviewIcon, IcMore_default as MoreIcon, IcNewBell_default as NewBellIcon, IcNewIssue_default as NewIssueIcon, IcNewReport_default as NewReportIcon, IcNewTab_default as NewTabIcon, IcNext_default as NextIcon, IcNotice_default as NoticeIcon, IcNoticeLine_default as NoticeLineIcon, IcOverview_default as OverviewIcon, IcPassword_default as PasswordIcon, ImgPending_default as PendingIllustration, IcPhone_default as PhoneIcon, IcPlace_default as PlaceIcon, IcQrcode_default as QrcodeIcon, IcRadio_default as RadioIcon, IcReadChecklist_default as ReadChecklistIcon, IcReadIssue_default as ReadIssueIcon, IcReadReport_default as ReadReportIcon, IcRefresh_default as RefreshIcon, IcRemove_default as RemoveIcon, ImgResolved_default as ResolvedIllustration, IcRightArrow_default as RightArrowIcon, ImgScheduled_default as ScheduledIllustration, IcSearch_default as SearchIcon, IcSection_default as SectionIcon, IcSettingFill_default as SettingFillIcon, IcSetting_default as SettingIcon, IcSheet_default as SheetIcon, IcSlider_default as SliderIcon, IcStatisticActive_default as StatisticActiveIcon, IcStatisticDefault_default as StatisticDefaultIcon, IcStatistics_default as StatisticsIcon, Subtract_default as SubtractIcon, IcText_default as TextIcon, IcTime_default as TimeIcon, IcTrash_default as TrashIcon, ImgTutorial01_default as Tutorial01Illustration, ImgTutorial02_default as Tutorial02Illustration, ImgTutorial03_default as Tutorial03Illustration, IcTutorialCompleted_default as TutorialCompletedIcon, IcTutorial_default as TutorialIcon, IcUpArrow_default as UpArrowIcon, IcUpArrowSolid_default as UpArrowSolidIcon, ImgUpgrade_default as UpgradeIllustration, IcUser_default as UserIcon, IcViewOff_default as ViewOffIcon, IcViewOn_default as ViewOnIcon, IcWorker_default as WorkerIcon, IcYesno_default as YesnoIcon, createIcon, isShoplIcon };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map